import { render, staticRenderFns } from "./DynamicDocs.vue?vue&type=template&id=59bf9334&scoped=true"
import script from "./DynamicDocs.vue?vue&type=script&lang=js"
export * from "./DynamicDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf9334",
  null
  
)

export default component.exports